const getTopmostParent = () => {
  let win = window;
  while (win.parent && win.parent !== win) {
    win = win.parent;
  }
  return win;
};

export default getTopmostParent;
